import Vue from 'vue'
import axios from 'axios'
import i18n from '@/i18n'

export default {
  baseURL: process.env.BASE_URL + 'api/aggregatedreports',

  getAggregatedReportFiles(filter, options, cancelToken) {
    return axios.post('', {
        'PageSize': options ? options.pageSize : null,
        'Page': options ? options.page : null,
        'ClientIds': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'PropertyIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'ColumnFilter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
        'SortBy': (filter && filter.sortBy) ? filter.sortBy : null,
        'SortDescending': (filter && filter.sortDescending) ? filter.sortDescending : null,
      },
      { 
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        
        return Promise.reject(error);
      });
  },

  getAggregatedReportFile(aggregatedReportFileId, cancelToken) {
    return axios.get('get-report-file',
      {
        baseURL: this.baseURL,
        params: {
          'aggregatedreport-file-id': aggregatedReportFileId
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getAggregatedReportFilesPackage(aggregatedReportFileIds, cancelToken) {
    return axios.post('get-report-files-package', {
        'AggregatedReportFileIds': aggregatedReportFileIds,
      },
      { 
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawDataAggregated(filter, options, cancelToken) {
    return axios.post('get-raw-data-aggregated', {
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'AggregationLevel1': options ? options.aggregationLevel1 : null,
        'AggregationLevel2': options ? options.aggregationLevel2 : null,
        'PivotAggregationLevel2': options ? options.pivotAggregationLevel2 : null,
        'IsRanking': options ? options.isRanking : null,
        'TopResultCount': options ? options.topResultCount : null,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        'ClientlocationIds': (filter && _.size(filter.locations) > 0) ? filter.locations.join() : null,
        'SurveyInstanceStatusMinimum': filter ? filter.surveyInstanceStatusMinimum : null,
        'SurveyInstanceStatusMaximum': filter ? filter.surveyInstanceStatusMaximum : null,
        'PropertyIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'PropertyUseLogicalAnd': options ? options.propertyUseLogicalAnd : null,
        'KpiIds': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : null,
        'IncludeKpiPoints': options ? options.includeKpiPoints : null,
        'IncludeKpiPercentages':  options ? options.includeKpiPercentages : null,
        'IncludeClusterPoints': options ? options.includeClusterPoints : null,
        'IncludeClusterPercentages':  options ? options.includeClusterPercentages : null,
        'IncludeTestchecks': filter ? filter.includeTestchecks : null,
        'IncludeOverallPoints': options ? options.includeOverallPoints : null,
        'ColorizeResults':  options ? options.colorizeResults : null,
        'ColorizeBackground':  options ? options.colorizeBackground : null,
        'UseCompactLayout':  options ? options.useCompactLayout : null,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getAggregatedPdfReport(filter, options, cancelToken) {
    return axios.post('get-aggregated-pdf', {
        'SurveyId': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
        'PropertyValues': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        'SurveyInstanceStatusMinimum': filter ? filter.surveyInstanceStatusMinimum : null,
        'SurveyInstanceStatusMaximum': filter ? filter.surveyInstanceStatusMaximum : null,
        'KpiIds': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : null,
        'IncludeKpis': options ? options.includeKpis : null,
        'IncludeTestchecks': filter ? filter.includeTestchecks : null,
        'TargetGroup': (options && options.targetGroup) ? options.targetGroup : null,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  }
}